import { graphql } from 'gatsby'
import { JsonLd } from 'react-schemaorg';
import { Article } from 'schema-dts';

import Layout from '../../../components/layout'
import { DefaultHead } from '../../../components/seo'
import MagazineArticle from '../../../components/MagazineArticle';
import MostPopularProducts from '../../../components/MostPopularProducts'
import MostPopularProductsByBrand from '../../../components/MostPopularProducts/MostPopularProductsByBrand'
import Contact from '../../../components/Contact'
import MagazineTeaserByCategory from '../../../components/MagazineTeaser/MagazineTeaserByCategory'
import generateWatchProjectImage from '../../../utils/generateWatchProjectImage';
import { stripHtmlTagsFromString } from '../../../utils/stripHtmlTagsFromString';
import RecentlyAddedProducts from '../../../components/RecentlyAddedProducts';
import { BUYING_CATALOG_ROUTE } from '../../../utils/routes/const';


type ArticlePageProps = {
  data: {
    magazine: WatchProject21Api.Magazine
  }
}

const ComprarArticlePage = ({ data }: ArticlePageProps) => {
  const { magazine } = data;

  return (
    <Layout footerColor='bg-gray' hasStickyChildren>
      <JsonLd<Article>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: magazine.title,
          description: magazine.subTitle,
          name: magazine.title,
          image: generateWatchProjectImage(magazine.ogImage || magazine.topImage, magazine.title),
          dateCreated: magazine.createdAt,
          datePublished: magazine.createdAt,
          dateModified: magazine.createdAt,
          articleBody: `${magazine.topText} ${magazine.middleText} ${magazine.bottomText}`,
          articleSection: magazine.category,
          wordCount: `${(magazine?.topText?.length || 0) +
            (magazine?.middleText?.length || 0) +
            (magazine?.bottomText?.length || 0)
            }`,
          publisher: {
            '@type': 'Organization',
            name: 'WatchProject21',
            logo: {
              '@type': 'ImageObject',
              url: 'https://watchproject21.com/logo-white.svg',
            },
          },
          inLanguage: 'es',
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `https://watchproject21.com/magazine/${magazine.slug}`,
          },
          text: stripHtmlTagsFromString(`${magazine.topText} ${magazine.middleText} ${magazine.bottomText}`),
        }}
      />
      <MagazineArticle magazine={magazine} topComponent={<>
        <RecentlyAddedProducts />
        <Contact
          title='buy.contact.0.title'
          cta='buy.contact.cta'
          url={BUYING_CATALOG_ROUTE()}
          hasContactPerson={false}
        />
      </>} />
      {
        // magazine.category === 'buyingGuide'
        //   && magazine.brands
        //   && magazine.brands?.length > 0
        //   ? <MostPopularProductsByBrand brandName={magazine.brands[0].name} />
        //   :
        <MostPopularProducts />
      }
      <Contact title='buy.contact.0.title' />
      {magazine.category && <MagazineTeaserByCategory category={magazine.category} />}
      <div className="pb-40" />
    </Layout>
  )
}

export default ComprarArticlePage;

// TODO: types
export const Head = ({ location, data }) => {
  const { magazine } = data;

  return (
    <DefaultHead
      title={stripHtmlTagsFromString(magazine.metaTitle || magazine.title)}
      description={stripHtmlTagsFromString(magazine.metaDescription || magazine.topText)}
      pathname={location.pathname}
    >
      <meta name="og:image" content={generateWatchProjectImage(magazine.topImage, magazine.title)} />
      <meta name="twitter:image" content={generateWatchProjectImage(magazine.topImage, magazine.title)} />
    </DefaultHead>
  )
}

export const query = graphql`
  query($language: String!, $slug: String!) {
    magazine: magazine(slug: {eq: $slug}) {
      slug
      subTitle
      title
      createdAt
      ogImage
      metaTitle
      metaDescription
      topText
      topAltText
      topImage
      middleText
      middleAltText
      middleImage
      bottomText
      bottomAltText
      bottomImage
      category
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
